import logger from 'shared/services/logger'
import store from 'shared/store'
import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

import GkAirCategorySliderHorizontal from '.'

const GK_AIR_CATEGORY_SLIDER_PROPS_ATTRIBUTE =
  'data-gk-air-category-slider-props'

const getSliderProps = container => {
  const rawProps = container.getAttribute(
    GK_AIR_CATEGORY_SLIDER_PROPS_ATTRIBUTE
  )

  if (!rawProps) {
    return null
  }

  try {
    return JSON.parse(rawProps)
  } catch (error) {
    logger.error('Could not parse GK Air category slider props', { error })
    return null
  }
}

const mountGkAirCategorySliderHorizontal = async () => {
  const containers = [
    ...document.querySelectorAll(`[${GK_AIR_CATEGORY_SLIDER_PROPS_ATTRIBUTE}]`),
  ]

  if (!containers.length) {
    return
  }

  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()
  const i18n = await loadCatalogs(locale)

  containers.forEach(container => {
    const props = getSliderProps(container)

    if (!props) {
      return
    }

    hydrateWithHOCs({
      container,
      i18n,
    })(<GkAirCategorySliderHorizontal {...props} />)
  })
}

export { GK_AIR_CATEGORY_SLIDER_PROPS_ATTRIBUTE }

export default mountGkAirCategorySliderHorizontal
